import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useMemo, useRef } from 'react';
import { Input } from "../Input";
import { Menu } from "../Menu";
import { _EndAdornment, _DropdownContainer } from "./styles";
import ArrowDown from "../../icons/ArrowChevronDown";
export function Dropdown(_ref) {
  var children = _ref.children,
    MenuProps = _ref.MenuProps,
    InputProps = _ref.InputProps;
  var ref = useRef();
  var endAdornment = useMemo(function () {
    return /*#__PURE__*/React.createElement(_EndAdornment, {
      inputOpen: MenuProps.open
    }, /*#__PURE__*/React.createElement(ArrowDown, null));
  }, [MenuProps.open]);
  var inputProps = _objectSpread(_objectSpread({}, InputProps), {}, {
    InputProps: _objectSpread(_objectSpread({}, InputProps.InputProps), {}, {
      readOnly: true,
      endAdornment: endAdornment
    })
  });
  var onClick = useCallback(function () {
    if (MenuProps.setOpen) {
      MenuProps.setOpen(!(MenuProps !== null && MenuProps !== void 0 && MenuProps.open));
    }
  }, [MenuProps === null || MenuProps === void 0 ? void 0 : MenuProps.setOpen]);
  return /*#__PURE__*/React.createElement(_DropdownContainer, {
    fullWidth: InputProps === null || InputProps === void 0 ? void 0 : InputProps.fullWidth
  }, /*#__PURE__*/React.createElement("span", {
    onClick: onClick,
    ref: ref,
    style: {
      display: 'inline-block'
    }
  }, /*#__PURE__*/React.createElement(Input, inputProps)), /*#__PURE__*/React.createElement(Menu, _extends({}, MenuProps, {
    anchorRef: ref,
    fullWidth: true
  }), children));
}
Dropdown.defaultProps = {
  MenuProps: {},
  InputProps: {}
};